import { buildLevelHelpText, buildLatenessHelpText } from "@/utils/dailyMenuLevelHelpTexts";

export const readStatisticsChangeDate = (vm) => {
  const statistics = vm.$store.getters["metrics/getStatistics"];
  return statistics ? statistics.formulaChangeDate : null;
};

export const readLevelsChangeDate = (vm) => vm.$store.state.niveles.formulaChangeDate;

export default (readChangeDate) => ({
  computed: {
    levelHelpText() {
      return buildLevelHelpText(readChangeDate(this));
    },
    latenessHelpText() {
      return buildLatenessHelpText(readChangeDate(this));
    }
  }
});
